import LTR from "@brand-icons/global/fullscreen-open/fullscreen-open-ltr.svg";

import { iconFactory } from "../iconFactory";

export const FullscreenOpenIcon = iconFactory("FullscreenOpenIcon", LTR);
